export const selectAllBlogs = (state) => state.data;

export const selectBlogByPath = (state, path) => state.data.find(blog => blog.path === path);

export const selectAllImages = (state) => state.images;
